import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.5_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BuyTickets"] */ "/app/src/blocks/BuyTickets/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoachCTABlock"] */ "/app/src/blocks/CoachCTA/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/CoachList/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoachMapBlockClient"] */ "/app/src/blocks/CoachMap/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/Details/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LottieBlock"] */ "/app/src/blocks/Lottie/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/Media/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsTickerBlock"] */ "/app/src/blocks/NewsTicker/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhotoGallery"] */ "/app/src/blocks/PhotoGallery/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighImpactHero"] */ "/app/src/heros/HighImpact/index.tsx");
